import { FC, useState } from 'react';
import Dragger from 'antd/lib/upload/Dragger';

import { uploadFormDataFile } from 'utils/uploadFormDataFile';
import { PRODUCT_RESEARCH_API_URLS } from 'api/constants';
import { csvUploadContentByStatus, EImportFileStatuses } from 'components/ImportCsv/constants';

const CsvUpload: FC<any> = ({ setFileColumns }) => {
  const [uploadStatus, setUploadStatus] = useState<EImportFileStatuses>(EImportFileStatuses.Initial);

  const handleUpload = async({ file }: any) => {
    if (file.type !== 'text/csv') {
      return setUploadStatus(EImportFileStatuses.FileTypeError);
    }

    setUploadStatus(EImportFileStatuses.Uploading);
    const { success, data }: any = await uploadFormDataFile(file, PRODUCT_RESEARCH_API_URLS.products.uploadCsv);

    if (success) {
      setUploadStatus(EImportFileStatuses.Success);
      setFileColumns(data);
    } else {
      setUploadStatus(EImportFileStatuses.Error);
    }
  };

  return (
    <div className="w-p-100">
      <Dragger accept=".csv" maxCount={1} showUploadList={false} customRequest={handleUpload}>
        {csvUploadContentByStatus[uploadStatus]}
      </Dragger>
    </div>
  );
};

export default CsvUpload;
